export default {
    auth: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'home'}
        },
        {
            icon: 'mdi-store-outline',
            name: 'إدارة المتجر',
            noExact: true,
            to: {name: 'store'},
        },
        {
            icon: 'mdi-cart-outline',
            name: 'الطلبات',
            to: {name: 'orders'}
        },
        {
            icon: 'mdi-view-grid-outline',
            name: 'الأقسام',
            to: {name: 'categories'}
        },
        {
            icon: 'mdi-package-variant-closed',
            name: 'المنتجات',
            to: {name: 'products'}
        },
        {
            icon: 'mdi-account-multiple-outline',
            name: 'العملاء',
            to: {name: 'customers'}
        },
        {
            icon: 'mdi-ticket-percent-outline',
            name: 'كوبونات الخصم',
            to: {name: 'coupons'},
            if: 'allowCouponsPage',
        },
        {
            icon: 'mdi-truck-delivery-outline',
            name: 'مناطق التوصيل',
            to: {name: 'delivery-areas'}
        },
        {
            icon: 'mdi-email-outline',
            name: 'البريد الوارد',
            to: {name: 'inbox'},
            chip: 'unreadInboxCount',
            chipColor: 'ebadge',

        },
        {
            icon: 'mdi-file-document-multiple-outline',
            name: 'الدفع والفواتير',
            to: {name: 'bills'},
            chip: 'unpaidBillsCount',
            chipColor: 'ebadge',
            if: 'allowBillsPage',
        },
        {
            icon: 'mdi-cog-outline',
            name: 'اﻹعدادات',
            to: {name: 'settings'},
            divider: true,
        },
        {
            icon: 'mdi-information-outline',
            name: 'اعرف أكثر عنا',
            to: {name: 'about'},
            if: 'isWeb'
        },
        /* {
            icon: 'mdi-text-box-outline',
            name: 'سياسة الخصوصية',
            to: {name: 'privacy-policy'}
        }, */
        {
            icon: 'mdi-help',
            name: 'المساعدة',
            to: {name: 'help'}
        }
    ],
    guest: [
        {
            icon: 'mdi-home-outline',
            name: 'الصفحة الرئيسية',
            to: {name: 'welcome'}
        },
        {
            icon: 'mdi-account-plus-outline',
            name: 'حساب جديد',
            to: {name: 'register'}
        },
        {
            icon: 'mdi-login-variant',
            name: 'تسجيل الدخول',
            to: {name: 'login'}
        },
        {
            icon: 'mdi-information-outline',
            name: 'اعرف أكثر عنا',
            to: {name: 'about'},
        },
        {
            icon: 'mdi-text-box-outline',
            name: 'سياسة الخصوصية',
            to: {name: 'privacy-policy'}
        },
        {
            icon: 'mdi-help',
            name: 'المساعدة',
            to: {name: 'help'}
        }
    ]
}